import React from 'react';

const Feed = () => {
    return (
        <div>
            feed
        </div>
    );
};

export default Feed;